import { render, staticRenderFns } from "./CustomerGroupsPicker.vue?vue&type=template&id=639819a6"
import script from "./CustomerGroupsPicker.vue?vue&type=script&lang=js"
export * from "./CustomerGroupsPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupsPicker.vue?vue&type=style&index=0&id=639819a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports